import { Box } from '@wix/design-system';
import React, { useEffect, useRef } from 'react';
import { useStore } from 'react-redux';
import { MemoryRouter } from 'react-router-dom';

import { clientSdk } from '../common/ClientSDK';
import { useFedopsLogger } from '../common/providers/fedopsLogger';
import { selectBiData } from '../common/selectors/chat';
import { helpCenterService } from '../common/services/helpCenter';
import { homepageService } from '../common/services/homepage/homepageService';
import { appRoutes } from '../react-router';
import { classNames } from '../util';
import { addWixRecorder, biHelpCenter } from '../util/bi';
import { navigationControl } from '../util/navigationControl';
import { renderModel } from '../util/renderModel';
import { BIHelpCenterMonitor } from './components/BIHelpCenterMonitor';
import { HelpCenterFullPage } from './HelpCenterFullPage';
import { HelpCenterWidget } from './HelpCenterWidget';
import { useIsWixStudio } from './hooks';
import styles from './styles.scss';
import { HelpCenterProps } from './types';

const { isWidget } = renderModel.get();
const TWELVE_HOURS = 1000 * 60 * 60 * 12;

export const HelpCenter: React.FC<HelpCenterProps> = ({
  routerInitialEntries,
}) => {
  const fedopsLogger = useFedopsLogger();
  const store = useStore();
  const timeoutId = useRef<number | undefined>(undefined);
  const useFullPageView =
    homepageService.homepageEnabled && helpCenterService.isFullWidth;

  const isWixStudio = useIsWixStudio();

  useEffect(() => {
    const appState = store.getState();
    const biData = selectBiData(appState);

    addWixRecorder(biData);
    fedopsLogger.appLoaded();

    if (isWidget) {
      void clientSdk.clientAppLoaded();
    }

    timeoutId.current = window.setTimeout(() => {
      navigationControl.reload();
    }, TWELVE_HOURS);

    return () => {
      if (timeoutId.current) {
        window.clearTimeout(timeoutId.current);
      }
    };
  }, []);

  return (
    <MemoryRouter
      initialEntries={
        useFullPageView ? [appRoutes.chatbot()] : routerInitialEntries
      }
    >
      <BIHelpCenterMonitor biHelpCenter={biHelpCenter}>
        <Box
          direction="vertical"
          position="absolute"
          width="100%"
          height="100%"
          backgroundColor="D80"
          className={classNames([isWixStudio && styles.helpCenterWixStudio])}
        >
          {useFullPageView ? <HelpCenterFullPage /> : <HelpCenterWidget />}
        </Box>
      </BIHelpCenterMonitor>
    </MemoryRouter>
  );
};
